import { ReactComponent as EmptyPanelDroneIcon } from '@assets/components/panel/notification/empty-panel-drone-icon.svg';
import { Center, For, HStack, Text, VStack } from '@chakra-ui/react';
import { groupBy } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { CriticalityCategoryEnum, criticalityOrder } from '../monitoring.types';
import { getSensorCriticality, sortSensorByType } from '../monitoring.utils';
import { SortEnum, useMonitoringContext } from '../MonitoringContext';
import SensorCard from './SensorCard';

function CriticalityList() {
  const { filteredSensorOrSubSensorInfoList } = useMonitoringContext();
  const groupedByStatusCriticality = groupBy(filteredSensorOrSubSensorInfoList, (filteredSensorOrSubSensorInfo) => {
    return getSensorCriticality(filteredSensorOrSubSensorInfo);
  });

  if (filteredSensorOrSubSensorInfoList.length === 0) {
    return (
      <Center height="100%" width="100%">
        <VStack gap={3}>
          <EmptyPanelDroneIcon />
          <Text
            textStyle="lg"
            fontFamily="space"
            fontFeatureSettings="'liga' off"
            color="neutral.200"
            maxWidth="230px"
            textAlign="center"
            userSelect="none"
          >
            <FormattedMessage id="components.monitoring.noResult" />
          </Text>
        </VStack>
      </Center>
    );
  }

  return (
    <For
      each={Object.entries(groupedByStatusCriticality).sort(
        ([key], [key2]) =>
          criticalityOrder.indexOf(key as CriticalityCategoryEnum) -
          criticalityOrder.indexOf(key2 as CriticalityCategoryEnum),
      )}
    >
      {([category, sensorOrSubSensorInfoList], index) => (
        <VStack
          width="100%"
          height="100%"
          alignItems="start"
          gap={2}
          paddingBottom="18px"
          key={category}
          marginBottom={index === Object.entries(groupedByStatusCriticality).length - 1 ? 6 : 0}
        >
          <Text fontWeight="medium" color="neutral.300">
            <FormattedMessage
              id={`components.monitoring.criticality.${category}`}
              values={{ count: sensorOrSubSensorInfoList.length }}
            />
          </Text>
          <HStack gap={2} flexWrap="wrap">
            <For
              each={sensorOrSubSensorInfoList.toSorted((sensor1, sensor2) =>
                sortSensorByType(sensor1.configuration, sensor2.configuration),
              )}
            >
              {(sensorOrSubSensorInfo) => (
                <SensorCard
                  sensorOrSubSensorInfo={sensorOrSubSensorInfo}
                  type={SortEnum.CRITICALITY}
                  key={sensorOrSubSensorInfo.configuration.uniqueKey}
                />
              )}
            </For>
          </HStack>
        </VStack>
      )}
    </For>
  );
}

export default CriticalityList;
